// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"ad751fba","226":"c1c978ec","253":"f4592c94","318":"051a71eb","379":"de2e42a0","506":"1e2ded5f","572":"1c4e6efe","634":"58e49e31","755":"463d0027","842":"e1c14b3f","889":"ed4b3f26","892":"15118533","916":"91f89c65","933":"8a25a80b","941":"06382142"}[chunkId] + ".chunk.js";
};